<nz-tabset nzSize="large" [(nzSelectedIndex)]="taskType" (nzSelectedIndexChange)="onTabChange()">
  <nz-tab [nzTitle]="'syn_task.all_task' | translate"></nz-tab>
  <nz-tab [nzTitle]="'syn_task.failed_task' | translate"></nz-tab>
</nz-tabset>

<ng-container *ngIf="!initialized; else loaded">
  <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 10 }"></nz-skeleton>
</ng-container>

<ng-template #loaded>
  <ng-container *ngIf="listOfTask?.length; else empty">
    <div
      *ngFor="let task of listOfTask"
      class="v4-layout-list-item"
      [ngClass]="{
        'opacity-50': task.retried
      }"
    >
      <!-- line-1 -->
      <div class="flex flex-row items-center justify-between">
        <div class="flex flex-row items-center">
          <div
            class="status leading-[20px] mr-[12px] px-[8px] text-[12px] text-white rounded-[4px]"
            [ngClass]="{
              'bg-[#ff8846]': task.sync_status === TaskStatus.PartiallyFailed,
              'bg-[#ff391e]': task.sync_status === TaskStatus.Failed,
              'bg-[#2c80f0]': task.sync_status === TaskStatus.InProgress,
              'bg-[#83bf6e]': task.sync_status === TaskStatus.Success
            }"
          >
            {{ StatusMap[task.sync_status] | translate }}
          </div>

          <div class="ellipsis">
            <span>{{ task.title_str }}</span>
            <!-- <span class="ml-[12px] text-s">{{ task.create_time | dateformat : ['YMD', 'hms'] }}</span> -->
          </div>
        </div>

        <a
          *ngIf="task.sync_status === TaskStatus.Failed || task.sync_status === TaskStatus.PartiallyFailed"
          nz-button
          nzType="link"
          class="font-medium"
          [ngClass]="{
            'text-[#8d959f]': task.retried
          }"
          [nzLoading]="task.loading"
          (click)="$event.stopPropagation(); onClickRetry(task)"
        >
          {{ (task.retried ? "word.retried" : "word.retry") | translate }}
        </a>
      </div>

      <!-- line-2 -->
      <div class="flex flex-row items-center mt-[8px] cursor-pointer">
        <div class="text-[14px] text-[#34383c]" [innerHtml]="task.format_str | html">
          <!-- {{ task.format_str }} -->
        </div>
      </div>

      <!-- line-3 -->
      <div class="flex flex-row items-center mt-[8px]">
        <div class="text-[13px] text-[#8d959f]">
          {{ task.create_time | dateformat: ["YMD", "hms"] }} {{ task.reservation_code }}
        </div>
      </div>

      <!-- line-4 -->
      <div *ngIf="task.failed_reason" class="flex flex-row items-center mt-[8px]">
        <div
          class="text-[13px] text-red-500"
          [ngClass]="{
            '!text-[#BD4A0A]': task.warning
          }"
        >
          <ng-container *ngIf="task.warning; else failReason">
            <span nz-icon nzType="exclamation-circle" nzTheme="outline"></span>
          </ng-container>

          <ng-template #failReason>
            <span>{{ "word.fail_reason" | translate }}</span>
          </ng-template>
          {{ task.failed_reason }}
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #empty>
    <div class="v4-layout-empty my-[100px]">
      <img class="v4-layout-empty-img" src="/assets/icon/no_data.png" />
      <div class="v4-layout-empty-content">
        <div class="v4-layout-empty-title">{{ "word.no_data" | translate }}</div>
      </div>
    </div>
  </ng-template>
</ng-template>

<!-- <div *ngIf="false">
  <nz-spin [nzSpinning]="loading">
    <ng-container *ngIf="taskList.length; else empty">
      <div
        *ngFor="let task of taskList"
        class="v4-layout-list-item"
        [ngClass]="{
          'opacity-50': task.retried
        }"
      >
        <div class="flex flex-row items-center justify-between">
          <div class="flex flex-row items-center">
            <div class="status-tag" [style.background]="task?.color">
              {{ task?.status }}
            </div>
            <div class="mx-2">
              {{ task?.house_title }}
            </div>
            <div class="time">
              {{ task?.create_time | dateformat }}
            </div>
          </div>

          <div class="operate">
            <a nz-button nzType="link" nzSize="small" *ngIf="task?.sync_status === 3" (click)="retry(task)">
              重试
              {{ (task.retried ? "word.retried" : "word.retry") | translate }}
            </a>
            <a class="ml-2" nz-button nzType="link" nzSize="small" (click)="toHouseStatusDetail(task)">
              查看详情
              {{ 'word.view_details' | translate }}
            </a>
          </div>
        </div>

        <div class="flex flex-row items-center mt-2">
          <div class="thirdparty mr-2">
            {{ "word.channel_" + task?.thirdparty_type | translate }}
          </div>
          <div class="text-[#a2a2a2]" *ngIf="task.task_type !== 2">
            {{ task?.begin | dateformat: ["MD"] }} ~
            {{ task?.end | dateformat: ["MD"] }}
          </div>
          <div class="mx-1" *ngFor="let item of task?.change" [ngSwitch]="item?.type">
            <span class="change-bold" *ngSwitchCase="'house_price'">
              价格
              {{ "component.syn_task.price" | translate }}
            </span>
            <span class="change-bold" *ngSwitchCase="'house_inventory'">
              库存
              {{ "component.syn_task.reserve" | translate }}
            </span>
            <span class="change-bold" *ngSwitchCase="'house_status'">
              房态
              {{ "component.syn_task.availability" | translate }}
            </span>
            <span class="change-bold" *ngSwitchCase="'daily_price'">
              基础价格
              {{ "component.syn_task.basic_price" | translate }}
            </span>
            <span class="change-bold" *ngSwitchCase="'weekend_price'">
              周末价格
              {{ "component.syn_task.weekend_price" | translate }}
            </span>
            <span
              class="ml-1"
              *ngIf="item?.from !== null"
              [innerHTML]="'syn_task.change_from_to' | translate: { from: item?.from, to: item?.to } | html"
            ></span>
            <span
              class="ml-1"
              *ngIf="item?.from === null"
              [innerHTML]="'syn_task.change_to' | translate: { to: item?.to } | html"
            ></span>
          </div>
        </div>
        <div class="mt-2 text-[#a2a2a2]">{{ task?.task_reason }}</div>

        失败原因或者警告

        失败
        <div class="mt-2 text-red-500" *ngIf="task?.sync_status === 3">
          <div class="fail">
            失败原因：
            {{ "word.fail_reason" | translate }}
            {{ task?.failed_message }}
          </div>
        </div>
        成功但警告
        <div class="mt-2 text-[#BD4A0A]" *ngIf="task?.sync_status === 4">
          <span nz-icon nzType="exclamation-circle" nzTheme="outline"></span>
          {{ task.failed_message }}
        </div>
      </div>
    </ng-container>
    <ng-template #empty>
      <div class="v4-layout-empty my-[100px]">
        <img class="v4-layout-empty-img" src="/assets/icon/no_data.png" />
        <div class="v4-layout-empty-content">
          <div class="v4-layout-empty-title">{{ "word.no_data" | translate }}</div>
        </div>
      </div>
    </ng-template>
  </nz-spin>
  <div class="text-right mt-6">
    <nz-pagination
      [(nzPageIndex)]="page"
      [nzTotal]="total"
      [nzPageSize]="pageSize"
      (nzPageIndexChange)="onPageChange()"
    ></nz-pagination>
  </div>
</div> -->
